/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandListItem,
    BrandListItemFromJSON,
    BrandListItemFromJSONTyped,
    BrandListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrandListResponse
 */
export interface BrandListResponse {
    /**
     * 
     * @type {Array<BrandListItem>}
     * @memberof BrandListResponse
     */
    items?: Array<BrandListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof BrandListResponse
     */
    totalRecords?: number;
}

export function BrandListResponseFromJSON(json: any): BrandListResponse {
    return BrandListResponseFromJSONTyped(json, false);
}

export function BrandListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(BrandListItemFromJSON)),
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function BrandListResponseToJSON(value?: BrandListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(BrandListItemToJSON)),
        'totalRecords': value.totalRecords,
    };
}


